import { lazy } from 'react';
import { AnyValue } from 'src/models/general.model';

export const mockFn = (..._args: AnyValue[]) => {
  return;
};

export const MockLazyComponent = lazy(() => import('src/__mocks__/EmptyComponent'));
